import projectsApi from '@/api/projects-api'
import router from '@/router'
import generalApi from '../../api/general-api'
import usersApi from '../../api/users-api'

const state = {
  user: {},
  items: [],
  accessLogs: [],
  journeyLogs: [],
  totalItems: 0,
  totalAccessLogs: 0,
  totalJourneyLogs: 0,
  selectUsers: [],
  checkJourney: [],
  roles: [],
}

const mutations = {
  setUser(state, val) {
    state.user = val
  },
  setCheckJourney(state, val) {
    state.checkJourney = val
  },
  setItems(state, val) {
    state.items = val
  },
  setTotalItems(state, val) {
    state.totalItems = val
  },
  setAccessLogs(state, val) {
    state.accessLogs = val
  },
  setTotalAccessLogs(state, val) {
    state.totalAccessLogs = val
  },
  setJourneyLogs(state, val) {
    state.journeyLogs = val
  },
  setTotalJourneyLogs(state, val) {
    state.totalJourneyLogs = val
  },
  setSelectUsers(state, val) {
    state.selectUsers = val
  },
  setRoles(state, val) {
    state.roles = val
  },
}

const actions = {
  async selectUsers({ commit }, { roles = '' }) {
    await usersApi.select(1, 999999, '', roles, 1)
      .then(
        response => {
          commit('setSelectUsers', response.data.data)
        },
        () => {
          commit('notifications', { title: 'Error en la búsqueda de usuarios.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  edit({ commit }, { id, user }) {
    commit('app/loading', true, { root: true })
    usersApi.edit(id, user)
      .then(
        () => {
          commit('notifications', { title: 'Usuario actualizado con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al actualizar usuario.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async getUser({ commit }, id) {
    commit('app/loading', true, { root: true })
    await usersApi.getUser(id)
      .then(
        response => {
          commit('setUser', response.data.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener el usuario.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  getListUsers({ commit }, {
    page, per_page, search = '', roles = ['super_admin', 'admin', 'operario'], active = 1,
  }) {
    commit('app/loading', true, { root: true })
    usersApi.list(page, per_page, search, roles, active)
      .then(
        response => {
          commit('setItems', response.data.data)
          commit('setTotalItems', response.data.meta.total[1])
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener el listado de usuarios.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  getAccessUsers({ commit }, {
    page, per_page, search = '', date_ini = '', date_fin = '', orderBy = '', user = '',
  }) {
    commit('app/loading', true, { root: true })
    usersApi.access(page, per_page, search, date_ini, date_fin, orderBy, user)
      .then(
        response => {
          commit('setAccessLogs', response.data.data)
          commit('setTotalAccessLogs', response.data.meta.total[1])
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener el listado de acceso.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  getJourneyLogs({ commit }, {
    page, per_page, search = '', date_ini = '', date_fin = '', orderBy = '', user = ''
  }) {
    commit('app/loading', true, { root: true })
    usersApi.journeyLogs(page, per_page, search, date_ini, date_fin, orderBy, user)
      .then(
        response => {
          commit('setJourneyLogs', response.data.data)
          commit('setTotalJourneyLogs', response.data.meta.total[1])
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener el listado de acceso.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  delete({ commit }, id) {
    commit('app/loading', true, { root: true })
    usersApi.delete(id)
      .then(
        () => {
          commit('notifications', { title: 'Usuario eliminado con éxito.', variant: 'success' }, { root: true })
          location.reload()
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al eliminar el usuario.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  create({ commit }, { user }) {
    commit('app/loading', true, { root: true })
    usersApi.create(user)
      .then(
        response => {
          commit('notifications', { title: 'Usuario creado con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          router.push({ name: 'editUser', params: { id: response.data.data.id } })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al crear usuario.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  restartJourney({ commit }, { user }) {
    commit('app/loading', true, { root: true })
    usersApi.restartJourney(user)
      .then(
        response => {
          commit('setCheckJourney', response.data.data)
          commit('notifications', { title: 'Jornada reanudada.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al crear usuario.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async checkJourney({ commit }, { user }) {
    commit('app/loading', true, { root: true })
    await usersApi.checkJourney(user)
      .then(
        response => {
          commit('setCheckJourney', response.data.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al checkear jornada del usuario.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  getRoles({ commit }) {
    commit('app/loading', true, { root: true })
    generalApi.roles()
      .then(
        response => {
          commit('setRoles', response.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener rols.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  resetPassword({ commit }, { id, oldPassword, newPassword }) {
    commit('app/loading', true, { root: true })
    return usersApi.resetPassword(id, oldPassword, newPassword).then(
      () => {
        commit(
          'notifications',
          {
            title: 'Contraseña actualizada con éxito.',
            variant: 'success',
          },
          { root: true },
        )
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
        return true
      },
      error => {
        commit('app/loading', false, { root: true })
        commit('setShowNotifications', true, { root: true })
        if (
          error.response.data.error
          && error.response.data.error === 'Old Password incorrect'
        ) {
          commit(
            'notifications',
            { title: 'Contraseña actual incorrecta', variant: 'danger' },
            { root: true },
          )
        } else {
          commit(
            'notifications',
            {
              title: 'Error al actualizar la contraseña.',
              variant: 'danger',
            },
            { root: true },
          )
        }
        commit('setShowNotifications', true, { root: true })
        return false
      },
    )
  },
}

const getters = {
  getUser: state => state.user,
  getItems: state => state.items,
  getAccessLogs: state => state.accessLogs,
  getTotalAccessLogs: state => state.totalAccessLogs,
  getJourneyLogs: state => state.journeyLogs,
  getTotalJourneyLogs: state => state.totalJourneyLogs,
  getTotalItems: state => state.totalItems,
  getSelectUsers: state => state.selectUsers,
  getRoles: state => state.roles,
  getCheckJourney: state => state.checkJourney,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
